import React from "react";
import { Calendar, FileUp, MessageCircle, Heart } from "lucide-react";
import QuickActionButton from "../global/QuickActionButton";

export default function HomeQuickActions({
  onBook,
  onUploadDocument,
  onMessages,
  onMyDoctors,
}) {
  return (
    <section className="p2-qa-section">
      <p className="p2-qa-title">Veprime të shpejta</p>

      <div className="p2-qa-grid">
        <QuickActionButton
          icon={Calendar}
          label="Rezervo takim"
          description="Gjej një mjek dhe prenoto."
          onClick={onBook}
        />
        <QuickActionButton
          icon={FileUp}
          label="Ngarko dokument"
          description="Analiza, epikriza, receta."
          onClick={onUploadDocument}
        />
        <QuickActionButton
          icon={MessageCircle}
          label="Mesazhe"
          description="Bisedo me mjekët e tu."
          onClick={onMessages}
        />
        <QuickActionButton
          icon={Heart}
          label="Mjekët e mi"
          description="Shiko mjekët që ndjek."
          onClick={onMyDoctors}
        />
      </div>
    </section>
  );
}
